import React, { Component } from "react";

const Stepper = (_) => {
  return (
    <div className="bg-gray-100">
      <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <nav>
          <ul className=" rounded-md divide-y divide-gray-300 md:flex md:divide-y-0 shadow-sm">
            <li className="relative md:flex-1 md:flex flex-col ">
              <div className="relative">
                <a
                  href="#"
                  className="group flex items-center w-full border-gray-300 border border-r-0 bg-white rounded-l"
                  style={{ minHeight: "94px" }}
                >
                  <div className="px-6 py-4 flex items-center text-sm leading-5 font-medium space-x-4">
                    <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                      <p className="text-indigo-600">01</p>
                    </div>
                    <p className="text-sm leading-5 font-medium text-gray-900">
                      Salt Automation Engine
                    </p>
                  </div>
                </a>
                <div className="hidden md:block absolute top-0 right-0 h-full w-5">
                  <svg
                    className="h-full w-full text-gray-300"
                    viewBox="0 0 22 80"
                    fill="none"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      vectorEffect="non-scaling-stroke"
                      stroke="currentcolor"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <ul className="px-6 py-4 bg-gray-100 list-disc cursor-pointer">
                <li className=" stepper-items">Event-driven automation</li>
                <li className=" stepper-items">
                  Cloud provisioning and control
                </li>
                <li className=" stepper-items">Remote execution</li>
                <li className=" stepper-items">Orchestration</li>
                <li className=" stepper-items">Multi-OS support</li>
                <li className=" stepper-items">Multi-system support</li>
                <li className=" stepper-items">Configuration management</li>
                <li className=" stepper-items">
                  Agent, agentless (SSH), or proxy agent
                </li>
              </ul>
            </li>

            <li className="relative md:flex-1 md:flex flex-col ">
              <div className="relative">
                <a
                  href="#"
                  className="group flex items-center w-full border-gray-300 border border-r-0 border-l-0 bg-white"
                  style={{ minHeight: "94px" }}
                >
                  <div className="px-6 py-4 flex items-center text-sm leading-5 font-medium space-x-4">
                    <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                      <p className="text-indigo-600">02</p>
                    </div>
                    <p className="text-sm leading-5 font-medium text-gray-900">
                      Operations Framework
                    </p>
                  </div>
                </a>
                <div className="hidden md:block absolute top-0 right-0 h-full w-5">
                  <svg
                    className="h-full w-full text-gray-300"
                    viewBox="0 0 22 80"
                    fill="none"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      vector-effect="non-scaling-stroke"
                      stroke="currentcolor"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <ul className="px-6 py-4 bg-gray-100 list-disc cursor-pointer">
                <li className=" stepper-items"> Multi-master scale</li>
                <li className=" stepper-items"> API endpoints</li>
                <li className=" stepper-items"> Persistent data storage</li>
                <li className=" stepper-items"> LDAP/AD integration</li>
                <li className=" stepper-items"> Failover protection</li>
                <li className=" stepper-items"> Job history</li>
                <li className=" stepper-items"> User history </li>
                <li className=" stepper-items"> Third-party integrations</li>
                <li className=" stepper-items"> Agentless Windows </li>
                <li className=" stepper-items"> Enterprise proxy </li>
              </ul>
            </li>

            <li className="relative md:flex-1 md:flex flex-col ">
              <div className="relative">
                <a
                  href="#"
                  className="group flex items-center w-full border-gray-300 border border-r-0 border-l-0 bg-white"
                  style={{ minHeight: "94px" }}
                >
                  <div className="px-6 py-4 flex items-center text-sm leading-5 font-medium space-x-4">
                    <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                      <p className="text-indigo-600">03</p>
                    </div>
                    <p className="text-sm leading-5 font-medium text-gray-900">
                      Commande & Control console
                    </p>
                  </div>
                </a>
                <div className="hidden md:block absolute top-0 right-0 h-full w-5">
                  <svg
                    className="h-full w-full text-gray-300"
                    viewBox="0 0 22 80"
                    fill="none"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      vector-effect="non-scaling-stroke"
                      stroke="currentcolor"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <ul className="px-6 py-4 bg-gray-100 list-disc cursor-pointer">
                <li className=" stepper-items"> Intuitive user interface</li>
                <li className=" stepper-items"> Role-based access controls</li>
                <li className=" stepper-items"> Bulk job orchestration</li>
                <li className=" stepper-items"> Job scheduler </li>
                <li className=" stepper-items">
                  Audit-ready charts and reports
                </li>
              </ul>
            </li>
            <li className="relative md:flex-1 md:flex flex-col">
              <a
                href="#"
                className="group flex items-center bg-white border border-l-0 rounded-r"
                style={{ minHeight: "94px" }}
              >
                <div className="px-6 py-4 flex items-center text-sm leading-5 font-medium space-x-4">
                  <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                    <p className="text-indigo-600">04</p>
                  </div>
                  <p className="text-sm leading-5 font-medium text-gray-900 group-hover:text-gray-900 transition ease-in-out duration-150">
                    SaltStack SecOps (add on)
                  </p>
                </div>
              </a>
              <ul className="px-6 py-4 bg-gray-100 list-disc cursor-pointer">
                <li className=" stepper-items">
                  {" "}
                  Live access to curated security profile library
                </li>
                <li className=" stepper-items"> Item-level policy checks</li>
                <li className=" stepper-items">
                  {" "}
                  Auto-remediation for continuous compliance
                </li>
                <li className=" stepper-items"> Encrypted data record</li>
                <li className=" stepper-items">
                  {" "}
                  CIS-certified benchmarks for dozens of policies.
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Stepper;
